import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	header: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "space-between",
		borderBottom   : `1px solid ${ theme.other.colors.border.primary }`,
		padding        : "1.25em 1.5em"
	},
	titleContainer: {
		display    : "flex",
		alignItems : "center"
	},
	title: {
		fontSize : "2rem",
		padding  : "0 0.5rem"
	},

	closeIcon: {
		cursor: "pointer",
		...theme.other.svgIcons.size30
	},

	backIcon: {
		width       : "3rem\nrem",
		cursor      : "pointer",
		height      : "3rem",
		paddingTop  : "0.5rem",
		marginRight : "1rem"
	}

} ) );
